meedy.controller('meedy.popupCreateAlabReferralController', ['$scope', '$state', '$q', '$mdDialog', '$timeout', '$translate', 'objectHelper',
    'baseModel', 'applicationModel', 'meedy.ALABModel', 'meedy.patientModel', 'referralModel', 'meedy.termModel',
    'meedy.dictionaryModel', 'meedy.userModel',
    function ($scope, $state, $q, $mdDialog, $timeout, $translate, objectHelper, baseModel, applicationModel, ALABModel,
              patientModel, referralModel, termModel, dictionaryModel, userModel) {

        function beforeSave() {
            // mapping externalSystsmID as normal id for Meedy context
            $scope.referral.alabOffers = $scope.referral.alabOffers.map(function (offer) {
                return new ALABOfferVO(offer.id, offer.name);
            })
        }

        function addNewOffer(newOffer) {
            if (!$scope.referral.alabOffers) {
                $scope.referral.alabOffers = [];
            }

            $scope.preDefinedOfferList.forEach(function (offer) {
                if (offer.id == newOffer.id) {
                    offer.selected = true;
                }
            });

            var offer = new ALABOfferVO(newOffer.id, newOffer.name);
            $scope.referral.alabOffers.push(offer);
            $scope.newOffer = undefined;
            $scope.searchOfferText = '';
            $scope.searchPatientText = '';
            if ($scope.noOffersAdded) {
                $scope.noOffersAdded = !$scope.noOffersAdded;
            }
        }

        function setData() {
            $scope.Enum = Enum;

            $scope.presentDate = new Date();
            $scope.doctor = null;
            $scope.referral = new ReferralVO();
            $scope.referral.dateOfIssue = new Date();
            $scope.referral.type = Enum.REFERRAL_TYPE.ALAB;
            $scope.referral.patient = $scope.patient;
            $scope.referral.payer = null;
            $scope.newOffer = undefined;

            $scope.laboratoryTestCategories = [];
            $scope.examinationTypes = Object.keys(Enum.EXAMINATION_TYPE);

            $scope.forms = {
                referral: null,
                newPatient: null
            };

            $scope.init = true;
            $scope.activeStep = 'offers';
            $scope.noOffersAdded = false;

            $scope.preDefinedOfferList = [
                {
                    icd9: "I09",
                    id: 160,
                    name: "Albumina - surowica",
                    selected: false
                },
                {
                    icd9: "I17",
                    id: 162,
                    name: "Aminotransferaza alaninowa - ALT (GPT)",
                    selected: false
                },
                {
                    icd9: "I19",
                    id: 163,
                    name: "Aminotransferaza asparaginianowa - AST (GOT)",
                    selected: false
                },
                {
                    icd9: "I25",
                    id: 166,
                    name: "Amylaza - surowica",
                    selected: false
                },
                {
                    icd9: "I77",
                    id: 174,
                    name: "Białko całkowite - surowica",
                    selected: false
                },
                {
                    icd9: "I81",
                    id: 177,
                    name: "Białko ostrej fazy - CRP - ilościowo",
                    selected: false
                },
                {
                    icd9: "I81",
                    id: 179,
                    name: "Białko C-reaktywne o wysokiej czułości (hsCRP)",
                    selected: false
                },
                {
                    icd9: "I89",
                    id: 180,
                    name: "Bilirubina całkowita - surowica",
                    selected: false
                },
                {
                    icd9: "O93",
                    id: 182,
                    name: "Całkowita zdolność surowicy do wiązania żelaza - TIBC",
                    selected: false
                },
                {
                    icd9: "I99",
                    id: 189,
                    name: "Cholesterol całkowity",
                    selected: false
                },
                {
                    icd9: "K01",
                    id: 190,
                    name: "Cholesterol HDL",
                    selected: false
                },
                {
                    icd9: "K03",
                    id: 191,
                    name: "Cholesterol LDL metodą bezpośrednią",
                    selected: false
                },
                {
                    icd9: "L11",
                    id: 202,
                    name: "Fosfataza alkaliczna - ALP",
                    selected: false
                },
                {
                    icd9: "L15",
                    id: 205,
                    name: "Fosfataza kwaśna – całkowita - AcP",
                    selected: false
                },
                {
                    icd9: "L31",
                    id: 215,
                    name: "Gammaglutamylotranspeptydaza - GGTP",
                    selected: false
                },
                {
                    icd9: "L43",
                    id: 225,
                    name: "Glukoza na czczo we krwi żylnej",
                    selected: false
                },
                {
                    icd9: "L55",
                    id: 229,
                    name: "Hemoglobina glikowana",
                    selected: false
                },
                {
                    icd9: "M18",
                    id: 237,
                    name: "Kinaza kreatynowa - CK",
                    selected: false
                },
                {
                    icd9: "M37",
                    id: 243,
                    name: "Kreatynina – mocz",
                    selected: false
                },
                {
                    icd9: "M37",
                    id: 244,
                    name: "Kreatynina – mocz dobowy",
                    selected: false
                },
                {
                    icd9: "M37",
                    id: 245,
                    name: "Kreatynina – surowica",
                    selected: false
                },
                {
                    icd9: "M45",
                    id: 251,
                    name: "Kwas moczowy - mocz",
                    selected: false
                },
                {
                    icd9: "M45",
                    id: 252,
                    name: "Kwas moczowy - mocz dobowy",
                    selected: false
                },
                {
                    icd9: "M45",
                    id: 253,
                    name: "Kwas moczowy - surowica",
                    selected: false
                },
                {
                    icd9: "N13",
                    id: 268,
                    name: "Mocznik - mocz dobowy",
                    selected: false
                },
                {
                    icd9: "N13",
                    id: 269,
                    name: "Mocznik - surowica",
                    selected: false
                },
                {
                    icd9: "N13",
                    id: 270,
                    name: "Mocznik (mocz)",
                    selected: false
                },
                {
                    icd9: "N45",
                    id: 278,
                    name: "Potas – mocz",
                    selected: false
                },
                {
                    icd9: "N45",
                    id: 279,
                    name: "Potas – mocz dobowy",
                    selected: false
                },
                {
                    icd9: "N45",
                    id: 280,
                    name: "Potas – surowica",
                    selected: false
                },
                {
                    icd9: "O35",
                    id: 287,
                    name: "Sód – mocz dobowy",
                    selected: false
                },
                {
                    icd9: "O35",
                    id: 288,
                    name: "Sód – surowica",
                    selected: false
                },
                {
                    icd9: "O43",
                    id: 291,
                    name: "Transferyna",
                    selected: false
                },
                {
                    icd9: "O49",
                    id: 294,
                    name: "Trójglicerydy TG",
                    selected: false
                },
                {
                    icd9: "O77",
                    id: 298,
                    name: "Wapń - mocz dobowy",
                    selected: false
                },
                {
                    icd9: "O77",
                    id: 299,
                    name: "Wapń całkowity - surowica",
                    selected: false
                },
                {
                    icd9: "O95",
                    id: 307,
                    name: "Żelazo na czczo - surowica",
                    selected: false
                },
                {
                    icd9: "I87",
                    id: 2292,
                    name: "Bilirubina związana (bezpośrednia)",
                    selected: false
                },
                {
                    icd9: "K03",
                    id: 5387,
                    name: "Cholesterol LDL wyliczany",
                    selected: false
                },
                {
                    icd9: "C55",
                    id: 138,
                    name: "Eozynofilia bezwzględna - krew",
                    selected: false
                },
                {
                    icd9: "C55",
                    id: 145,
                    name: "Morfologia pełna – analizator – krew",
                    selected: false
                },
                {
                    icd9: "C59",
                    id: 149,
                    name: "OB – odczyn Biernackiego",
                    selected: false
                },
                {
                    icd9: "C69",
                    id: 152,
                    name: "Retikulocyty - krew",
                    selected: false
                },
                {
                    icd9: "L69",
                    id: 382,
                    name: "Hormon tyreotropowy - TSH",
                    selected: false
                },
                {
                    icd9: "O55",
                    id: 430,
                    name: "Trójjodotyronina wolna - fT3",
                    selected: false
                },
                {
                    icd9: "O69",
                    id: 435,
                    name: "Tyroksyna wolna - fT4",
                    selected: false
                },
                {
                    icd9: "K21",
                    id: 544,
                    name: "Czynnik reumatoidalny - ilościowo",
                    selected: false
                },
                {
                    icd9: "K21",
                    id: 5392,
                    name: "Czynnik reumatoidalny RF IgM",
                    selected: false
                },
                {
                    icd9: "K21",
                    id: 5393,
                    name: "Czynnik reumatoidalny RF IgG",
                    selected: false
                },
                {
                    icd9: "K21",
                    id: 446,
                    name: "HBs-antygen",
                    selected: false
                },
                {
                    icd9: "A17",
                    id: 128,
                    name: "Kał - krew utajona",
                    selected: false
                },
                {
                    icd9: "A21",
                    id: 133,
                    name: "Kał - Pasożyty",
                    selected: false
                },
                {
                    icd9: "A23",
                    id: 135,
                    name: "Kał na stopień strawienia",
                    selected: false
                },
                {
                    icd9: "G11",
                    id: 326,
                    name: "APTT (czas kaolinowo-kefalinowy)",
                    selected: false
                },
                {
                    icd9: "G53",
                    id: 345,
                    name: "Fibrynogen",
                    selected: false
                },
                {
                    icd9: "G21",
                    id: 5150,
                    name: "PT (INR)",
                    selected: false
                },
                {
                    icd9: "A01",
                    id: 1522,
                    name: "Mocz – badanie ogólne",
                    selected: false
                },
                {
                    icd9: "A07",
                    id: 109,
                    name: "Mocz - białko",
                    selected: false
                },
                {
                    icd9: "O35",
                    id: 120,
                    name: "Mocz - sód",
                    selected: false
                },
                {
                    icd9: "O77",
                    id: 1527,
                    name: "Mocz - wapń",
                    selected: false
                },
                {
                    icd9: "A07",
                    id: 122,
                    name: "Mocz dobowy - białko",
                    selected: false
                },
                {
                    icd9: "A15",
                    id: 3807,
                    name: "Glukoza w DZM",
                    selected: false
                },
                {
                    icd9: "I61",
                    id: 744,
                    name: "Antygen swoisty dla prostaty - PSA całkowity",
                    selected: false
                }
            ];

            $scope.preDefinedOfferList.sort(function (a,b) {
                return (a.name < b.name) ? -1 : 1;
            });

            $scope.showPreDefinedOffers = false;
            $scope.patientMode = Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.EXISTING;
            $scope.newPatient = new PatientMeedyVO();

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch('newOffer', function (newVal) {
                if (newVal) {
                    addNewOffer(newVal);
                }
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, function (ev, data) {
                $scope.stateList = data.data;
            })

        }

        function setActions() {
            $scope.save = function (print) {
                // beforeSave();

                $scope.forms.referral.$setSubmitted();
                if ($scope.forms.referral.$valid) {


                    var _patient = $scope.getProperPatientContext();

                    var _shortReferralRequest = {
                        patient: _patient.id ? { id: _patient.id } : _patient,
                        resourceId: $scope.referral.alabResource.id,
                        offers: $scope.referral.alabOffers,
                        paymentType: userModel.currentUser.medicalPost.alabPaymentType
                    };

                    if(!_shortReferralRequest.patient.id) {
                        _shortReferralRequest.patient.identifierType = Enum.IDENTIFIER_TYPE.PESEL;
                    }

                    termModel.createAlabAppointment(_shortReferralRequest).then(function (ref) {
                        $mdDialog.hide();
                    });
                }
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.removeOffer = function (idx) {
                $scope.preDefinedOfferList.forEach(function (offer) {
                    if (offer.id == $scope.referral.alabOffers[idx].id) {
                        offer.selected = false;
                    }
                });

                $scope.referral.alabOffers.splice(idx, 1);
            };

            $scope.nextStep = function () {
                if ($scope.activeStep === 'offers') {
                    if (!$scope.referral.alabOffers.length) {
                        $scope.noOffersAdded = true;
                        return false;
                    }
                    var meedyOffers = new MeedyOffersWrapper();
                    meedyOffers.offers = $scope.referral.alabOffers.map(function(offer) {
                        return { id: offer.id }
                    });

                    var _patient = $scope.getProperPatientContext();

                    ALABModel.getResources(meedyOffers).then(function (dataPage) {
                        $scope.resources = (dataPage.resources.length) ? dataPage.resources : [];
                        $scope.activeStep = 'resources';

                        $scope.resources.forEach(function (resource) {
                            resource.id = resource.id;
                        });

                        var list = [];

                        list = $scope.resources.filter(function (resource) {
                            return resource.address.city === _patient.address.city;
                        });

                        $scope.resources = $scope.resources.filter(function (resource) {
                            return resource.address.city != _patient.address.city;
                        });

                        $scope.resources = list.concat($scope.resources);
                    })
                }
                if ($scope.activeStep === 'resources') {
                    if ($scope.referral.alabResource) {
                        $scope.activeStep = 'delegate';
                    }
                }
            };

            $scope.previousStep = function () {
                if ($scope.activeStep === 'resources') {
                    $scope.activeStep = 'offers';
                }
                if ($scope.activeStep === 'delegate') {
                    $scope.activeStep = 'resources';
                }
            };

            $scope.querySearchOffers = function (query) {
                var criteria = {rowsPerSheet: Constant.NUMBER.INT_MAX_VALUE, searchPhrase: query};
                var deferred = $q.defer();
                ALABModel.getDataPage(criteria).then(function (dataPage) {
                    $scope.items = dataPage.offers;
                    deferred.resolve($scope.items);
                });
                return deferred.promise;
            };

            $scope.querySearchPatients = function (query) {
                var criteria = {rowsPerSheet: Constant.NUMBER.INT_MAX_VALUE, searchPhrase: query};
                var deferred = $q.defer();
                patientModel.getPatientList(criteria).then(function (dataPage) {
                    dataPage.forEach(function (item) {
                        item.fullName = item.firstName + ' ' + item.lastName;
                    });
                    deferred.resolve(dataPage);
                });
                return deferred.promise;
            };

            $scope.querySearch = function (query) {
                return query ? $scope.resources.filter($scope.searchForResource(query)) : $scope.resources;
            };

            $scope.searchForResource = function (q) {
                return function filterFunc(resource) {
                    return (resource.name.indexOf(q) != -1);
                }
            };

            $scope.actionForPreDefinedOffer = function (offer) {
                if (offer.selected) {
                    addNewOffer(offer);
                } else {
                    var idx = _.findIndex($scope.referral.alabOffers, {id: offer.id})
                    $scope.removeOffer(idx);
                    offer.selected = false;
                }
            };

            $scope.changePatientMode = function (mode) {
                $scope.patientMode = mode;

                if ($scope.patientMode === Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.EXISTING) {
                    $scope.newPatient = new PatientMeedyVO();
                    $scope.forms.newPatient.$setPristine();
                } else {
                    $scope.referral.patient = null;
                }
            };

            $scope.getProperPatientContext = function () {
                return ($scope.patientMode === Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.NEW) ? $scope.newPatient : $scope.referral.patient;
            }

        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);